<section modalContainer scrollEnabled>
    <app-modal-header header>카테고리 관리</app-modal-header>
    <div class="flex flex-col p-4 gap-4">
        <div class="flex w-full justify-end">
            <app-button (click)="isCreate.set(true)">카테고리 추가</app-button>
        </div>
        <div
            cdkDropList
            (cdkDropListDropped)="drop($event)"
            class="flex flex-col gap-1 w-[50rem] h-[50rem]"
        >
            @if (isCreate()) {
            <app-product-category-form
                [(value)]="category"
                (cancel)="isCreate.set(false)"
                (submit)="submit()"
            />
            } @for (c of categories(); track $index) {
            <app-product-category-item
                (refresh)="$categories.reload()"
                [category]="c"
            />
            } @empty {
            <div class="flex items-center justify-center h-full">
                <p class="text-gray-500">카테고리가 없습니다.</p>
            </div>
            }
        </div>
    </div>
</section>
